import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ElementRef, HostListener, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-animated-scroll',
  templateUrl: './animated-scroll.component.html',
  styleUrls: ['./animated-scroll.component.scss']
})
export class AnimatedScrollComponent {
  @Input() data : any;
  @Input() item : any;
  @Input() images : any;
  @ViewChild('leftImage') leftImage!: ElementRef<HTMLImageElement>;
  @ViewChild('rightSection') rightSection!: ElementRef<HTMLDivElement>;
  @ViewChildren('scrollItem') scrollItems!: QueryList<ElementRef<HTMLDivElement>>;
  isMobile = false;
  private lastScrollTop = 0;
  private scrollDirection: 'up' | 'down' = 'down';
  private animationFrameId: number | null = null;
  private maxScrollHeight = 0;
  private scrollRatio = 0;

   
  constructor(private breakpointObserver: BreakpointObserver){}
  ngAfterViewInit() {
    this.checkMobileView();
    this.setupIntersectionObserver();
    this.calculateMaxScrollHeight();
  }
  private checkMobileView() {
    this.breakpointObserver.observe([
      '(max-width: 959px)'
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }

  private calculateMaxScrollHeight() {
    if (this.rightSection?.nativeElement) {
      this.maxScrollHeight = this.rightSection.nativeElement.scrollHeight - window.innerHeight;
    }
  }

  private setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: this.buildThresholdList(30) // More granular thresholds
    };
  
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const item = entry.target as HTMLDivElement;
        const ratio = entry.intersectionRatio;
        
        // More dramatic scaling - from 0.5 to 1.0
        const scale = 0.5 + (ratio * 0.5);
        
        // More dramatic opacity - from 0 to 1
        const opacity = ratio;
        
        // Remove blur as item appears
        const blur = 2 - (ratio * 2);
        
        // Apply transforms
        item.style.transform = `scale(${scale})`;
        item.style.opacity = `${opacity}`;
        item.style.filter = `blur(${blur}px)`;
        
        // Add active class when mostly visible
        if (ratio > 0.7) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }, options);
  
    this.scrollItems.forEach(itemRef => {
      observer.observe(itemRef.nativeElement);
    });
  }
  
  private buildThresholdList(steps: number) {
    const thresholds = [];
    for (let i = 0; i <= steps; i++) {
      thresholds.push(i / steps);
    }
    return thresholds;
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }

    this.animationFrameId = requestAnimationFrame(() => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      
      // Calculate scroll ratio (0 to 1)
      this.scrollRatio = Math.min(1, Math.max(0, scrollTop / this.maxScrollHeight));
      
      this.updateLeftImageScale();
    });
  }

  private updateLeftImageScale() {
    if (this.leftImage?.nativeElement) {
      // Use scrollRatio for proportional scaling
      // Scale from 0.95 (at top) to 1.15 (at bottom)
      const scale = 0.95 + (this.scrollRatio * 0.2);
      this.leftImage.nativeElement.style.transform = `scale(${scale})`;
    }
  }

  ngOnDestroy() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  }

    public bannerServerPath = environment.commonImageApi + '/commonSlider/';
  
    public serverPath1 = environment.commonImageApi + '/home/';

}
